import React from "react";

export function linkify(text) {
  if (!text) return null;

  // http(s):// 或 www. 開頭
  const urlRegex = /((https?:\/\/|www\.)[^\s<]+[^\s<\.)\],!?])/gi;

  const elements = [];
  let lastIndex = 0;

  for (const match of text.matchAll(urlRegex)) {
    const url = match[0];
    const index = match.index;

    // 前面的純文字
    if (index > lastIndex) {
      elements.push(text.slice(lastIndex, index));
    }

    const href = url.startsWith("http") ? url : `https://${url}`;

    elements.push(
      React.createElement(
        "a",
        {
          key: `${index}-${url}`,
          href,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "chat-link",
        },
        url
      )
    );

    lastIndex = index + url.length;
  }

  // 剩下的文字
  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return elements;
}
